import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import Price from './pages/Price/Price';
import Support from './pages/Support/Support';
import POSBillingSofrware from './pages/POSBillingSofrware/POSBillingSofrware';
import Checkout from './pages/Checkout/Checkout';
import Download from './pages/Download/Download';
import Contact from './pages/Contact/Contact';
import PaymentSuccessfully from './pages/PaymentSuccessfully/PaymentSuccessfully';
import { PrivateRoute } from './routing/PrivateRoute';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import ForgotPassword from './pages/Auth/ForgotPassword';
import OtpVerify from './pages/Auth/OtpVerify';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<Register />} />
            <Route path='/password/forgot' element={<ForgotPassword />} />
            <Route path='/otp/verify' element={<OtpVerify />} />
            <Route path='/' element={<Home />} />
            <Route path='/buy-macrum' element={<Price />} />
            <Route path='/download' element={<Download />} />
            <Route path='/pos-billing-software' element={<POSBillingSofrware />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/support' element={<Support />} />
            <Route path='/checkout' element={<PrivateRoute><Checkout /></PrivateRoute>} />
            <Route path='/payment-success' element={<PrivateRoute><PaymentSuccessfully /></PrivateRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
